import { Stack, styled } from '@mui/material';
import { NEW_COLORS } from '../../../../themes/colors/newColors';

export const StyledCard = styled(Stack)(() => ({
  padding: '16px',
  borderRadius: 8,
  border: `1px solid ${NEW_COLORS.GRAYSCALE[100]}`,
  backgroundColor: NEW_COLORS.BASE.WHITE,
}));
